// Navigation mega menu JS #Krunal's-Script
const navItems = document.querySelectorAll('.navbar_nav .nav-item');
if (navItems) {
  navItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      navItems.forEach(el => el.classList.remove('active'));

      item.classList.add('active');
    });

    item.addEventListener('mouseleave', () => {
      item.classList.remove('active');
    });
  });
}

let newArrivalSlider = new Swiper(".new_arrival_slider", {
  slidesPerView: 1.1,
  spaceBetween: 8,
  centeredSlides: true,
  loop: true,
  initialSlide: 1,
  mousewheel: {
    forceToAxis: true, // Only respond to horizontal scroll
    releaseOnEdges: true,
    sensitivity: 0.5,
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  slideToClickedSlide: true,
  navigation: {
    nextEl: ".new_arrival_slider .swiper-button-next",
    prevEl: ".new_arrival_slider .swiper-button-prev",
  },
  breakpoints: {
    576: { slidesPerView: 1.2, spaceBetween: 12 },
    768: { slidesPerView: 1.8, spaceBetween: 12 },
    992: { slidesPerView: 1.8, spaceBetween: 12 },
    1200: { slidesPerView: 1.9, spaceBetween: 12, simulateTouch: false, allowTouchMove: false, grabCursor: false },
    1800: { slidesPerView: 1.6, spaceBetween: 12, simulateTouch: false, allowTouchMove: false },
  },
});


document.querySelectorAll(".best_sellers_slider").forEach((slider) => {
  const section = slider.closest(".best_sellers");

  new Swiper(slider, {
    slidesPerView: "auto",
    spaceBetween: 11,
    freeMode: false,
    cssMode: false,
    centeredSlides: true,
    loop: true,

    scrollbar: {
      el: section.querySelector(".swiper-scrollbar"),
      dragSize: "auto",
      draggable: true,
    },

    navigation: {
      nextEl: section.querySelector(".swiper-button-next"),
      prevEl: section.querySelector(".swiper-button-prev"),
    },

    pagination: {
      el: section.querySelector(".swiper-pagination"),
      clickable: true,
      dynamicBullets: true,
    },

    breakpoints: {
      0: {
        centeredSlides: true,
        loop: true,
      },

      576: {
        spaceBetween: 16,
      },

      768: {
        spaceBetween: 16,
      },

      992: {
        spaceBetween: 16,
        simulateTouch: false,
        allowTouchMove: false,
        grabCursor: false,
        centeredSlides: false,
        loop: false,
      },

      1440: {
        spaceBetween: 16,
        simulateTouch: false,
        allowTouchMove: false,
      },
    },
  });
});


var swiper = new Swiper(".oc_slider", {
  slidesPerView: 1.1,
  spaceBetween: 10,
  speed: 800,
  loop:true,
  direction: "horizontal",
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".oc_slider .swiper-button-next",
    prevEl: ".oc_slider .swiper-button-prev",
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true, // Ensures it only moves when the slider is in view
  },
  touchRatio: 2, // Increase touch sensitivity
  simulateTouch: true, // Allow simulated touch events
  grabCursor: true, // Show hand cursor when hovering
  mousewheel: {
    enabled: true,
    forceToAxis: true, // Scroll only in Swiper's direction
    sensitivity: 2, // Increase sensitivity
    releaseOnEdges: true, // Allow natural scroll stopping
  },

  breakpoints: {
    0: {
      autoHeight: true,
    },
    576: {
      slidesPerView: 1.1,
      spaceBetween: 15,
    },
    768: {
      autoHeight: false,
    },
    992: {
      slidesPerView: 1.05,
      spaceBetween: 15,
    },
    1200: {
      slidesPerView: 1.03,
      spaceBetween: 15,
    },
    1600: {
      slidesPerView: 1.06,
      spaceBetween: 15,
    },
    1800: {
      slidesPerView: 1.01,
      spaceBetween: 15,
    },
  },
});
/*
  Product recommendations slider init.

  Previously this used a one-shot setInterval that initialized Swiper the
  *first* time `.product_recommendation_slider` appeared in the DOM, then
  stopped checking forever (clearInterval). Because <product-recommendations>
  loads/replaces its content asynchronously, that first check could either
  fire too early (before the real slides exist) or get its DOM swapped out
  from under it afterward - leaving raw, un-initialized swiper-slide markup
  (stacked, full width, oversized image) with nothing left to fix it. A hard
  refresh just happened to change the timing enough to "accidentally" work.

  This version uses a MutationObserver scoped to each <product-recommendations>
  element's direct children, so Swiper is (re)initialized every time this
  element's content is first rendered OR later replaced - reliably, on every
  load, for every product, with no dependency on timing.
*/
function initProductRecommendationSlider(root) {
  var sliderEl = root.querySelector('.product_recommendation_slider');
  if (!sliderEl) return;
  if (!sliderEl.querySelectorAll('.swiper-slide').length) return;

  // If a previous instance is already attached to this exact node
  // (e.g. from an earlier init pass), tear it down first so we never
  // end up with duplicate/stale Swiper instances on the same element.
  if (sliderEl.swiper) {
    sliderEl.swiper.destroy(true, true);
  }

  new Swiper(sliderEl, {
    slidesPerView: 1.3,
    spaceBetween: 10,
    initialSlide: 0,
    mousewheel: {
      forceToAxis: true, // Only respond to horizontal scroll
      releaseOnEdges: true,
      sensitivity: 0.5,
    },
    pagination: {
      el: sliderEl.querySelector('.swiper-pagination'),
      clickable: true,
    },
    scrollbar: {
      el: sliderEl.querySelector('.swiper-scrollbar'),
      draggable: true,
    },
    navigation: {
      nextEl: sliderEl.querySelector('.swiper-button-next'),
      prevEl: sliderEl.querySelector('.swiper-button-prev'),
    },
    slideToClickedSlide: true,
    breakpoints: {
      450: {
        slidesPerView: 2.3,
        spaceBetween: 10,
      },
      576: {
        slidesPerView: 2.5,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 15,
        simulateTouch: false, allowTouchMove: false, grabCursor: false
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 15,
        simulateTouch: false, allowTouchMove: false
      },
      1400: {
        slidesPerView: 4,
        spaceBetween: 27,
        simulateTouch: false, allowTouchMove: false
      },
    },
  });
}

document.querySelectorAll('product-recommendations').forEach(function (root) {
  // Covers the common case: the slider content is already present on
  // first paint (server-rendered), so it works immediately - no reload
  // needed.
  initProductRecommendationSlider(root);

  // Covers the case where this element's content is fetched/replaced
  // asynchronously after first paint. Re-init whenever the new markup
  // lands, instead of giving up after a single check like before.
  // Scoped to direct children only (not subtree) so Swiper's own
  // internal DOM updates (pagination bullets, slide classes, etc.)
  // never re-trigger this observer.
  var pendingInit = false;
  var observer = new MutationObserver(function () {
    if (pendingInit) return;
    pendingInit = true;
    requestAnimationFrame(function () {
      pendingInit = false;
      initProductRecommendationSlider(root);
    });
  });
  observer.observe(root, { childList: true });
});

var commonSlider = new Swiper(".common_product_slider", {
  slidesPerView: 1,
  spaceBetween: 10,
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  navigation: {
    nextEl: ".common_product_slider .swiper-button-next",
    prevEl: ".common_product_slider .swiper-button-prev",
  },
  pagination: {
    el: ".common_product_slider .swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    450: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    576: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 15,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 15,
      simulateTouch: false, allowTouchMove: false, grabCursor: false
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 15,
      simulateTouch: false, allowTouchMove: false,
    },
    1400: {
      slidesPerView: 4,
      spaceBetween: 26,
      simulateTouch: false, allowTouchMove: false,
    },
  },
})

// Initialize Swiper
var cp_slider = new Swiper(".cp_slider", {
  spaceBetween: 20,
  speed: 1000,
  delay: 300,
  pagination: {
    el: ".swiper-pagination",
    clickable: true, // Ensure bullets are clickable
    dynamicBullets: true, // Set default to false; will update dynamically
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  touchRatio: 2,
  simulateTouch: true,
  grabCursor: true,
  mousewheel: {
    enabled: true,
    forceToAxis: true,
    sensitivity: 2,
    releaseOnEdges: true,
  },
  breakpoints: {
    0: {
      autoHeight: true,
    },
    768: {
      autoHeight: false,
    },
  },
});

// ODD EVEN SLIDER - ROOMS PAGE
// document.querySelectorAll(".odd_even_slider").forEach(function (sliderEl) {
//   if (sliderEl.swiper) return;

//   var isReversed = sliderEl.classList.contains("odd_even_slider_rev");

//   new Swiper(sliderEl, {
//     slidesPerView: "auto",
//     direction: "horizontal",
//     centeredSlides: false,
//     spaceBetween: 20,
//     speed: 800,
//     roundLengths: true,
//     keyboard: {
//       enabled: true,
//       onlyInViewport: true,
//     },
//     pagination: {
//       el: sliderEl.querySelector(".swiper-pagination"),
//       clickable: true,
//     },
//     touchRatio: 2,
//     simulateTouch: true,
//     grabCursor: true,
//     allowTouchMove: true,
//     mousewheel: {
//       enabled: true,
//       forceToAxis: true,
//       sensitivity: 2,
//       releaseOnEdges: true,
//     },
//     navigation: {
//       nextEl: sliderEl.querySelector(".swiper-button-next"),
//       prevEl: sliderEl.querySelector(".swiper-button-prev"),
//     },
//     on: {
//       init: function () {
//         // Trim phantom extra snap point that inflates pagination bullet count
//         if (this.snapGrid.length > this.slides.length) {
//           this.snapGrid = this.snapGrid.slice(0, this.slides.length);
//           this.pagination.render();
//           this.pagination.update();
//         }
//       },
//       slideChange: function () {
//         this.pagination.update();
//       },
//       resize: function () {
//         // Re-trim on resize too, since snapGrid recalculates
//         if (this.snapGrid.length > this.slides.length) {
//           this.snapGrid = this.snapGrid.slice(0, this.slides.length);
//           this.pagination.render();
//           this.pagination.update();
//         }
//       },
//     },
//     breakpoints: {
//       0: {
//         autoHeight: true,
//         spaceBetween: 0,
//         rtl: false,
//         allowTouchMove: true,
//       },
//       768: {
//         autoHeight: false,
//         spaceBetween: 15,
//         rtl: false,
//         allowTouchMove: true,
//       },
//       992: {
//         autoHeight: false,
//         spaceBetween: 20,
//         rtl: isReversed,
//         allowTouchMove: true,
//       },
//     },
//   });
// });

document.querySelectorAll(".odd_even_slider").forEach(function (sliderEl) {
  if (sliderEl.swiper) return;

  var isReversed = sliderEl.classList.contains("odd_even_slider_rev");

  function fixPagination(swiper) {
    // Remove phantom snap point that creates an extra bullet
    if (swiper.snapGrid.length > swiper.slidesGrid.length) {
      swiper.snapGrid = swiper.snapGrid.slice(0, swiper.slidesGrid.length);
    }

    swiper.pagination.render();
    swiper.pagination.update();
    swiper.updateSlidesClasses();
  }

  new Swiper(sliderEl, {
    slidesPerView: "auto",
    direction: "horizontal",
    centeredSlides: false,
    spaceBetween: 12,
    speed: 1000,
    roundLengths: true,

    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },

    pagination: {
      el: sliderEl.querySelector(".swiper-pagination"),
      clickable: true,
    },

    navigation: {
      nextEl: sliderEl.querySelector(".swiper-button-next"),
      prevEl: sliderEl.querySelector(".swiper-button-prev"),
    },

    touchRatio: 2,
    simulateTouch: true,
    grabCursor: true,
    allowTouchMove: true,

    mousewheel: {
      enabled: true,
      forceToAxis: true,
      sensitivity: 2,
      releaseOnEdges: true,
    },

    breakpoints: {
      0: {
        autoHeight: true,
        spaceBetween: 0,
        allowTouchMove: true,
      },
      768: {
        autoHeight: false,
        spaceBetween: 12,
        allowTouchMove: true,
      },
      992: {
        autoHeight: false,
        spaceBetween: 12,
        rtl: isReversed, // Keep only if your current setup requires it
        allowTouchMove: true,
      },
    },

    on: {
      init: function () {
        fixPagination(this);
      },

      resize: function () {
        this.update();
        fixPagination(this);
      },

      breakpoint: function () {
        this.update();
        fixPagination(this);
      },

      update: function () {
        fixPagination(this);
      },

      slideChange: function () {
        this.pagination.update();
      },
    },
  });
});

// var odd_even_slider = new Swiper(".odd_even_slider", {
//   slidesPerView: "auto",
//   direction: "horizontal",
//   centeredSlides: false,
//   spaceBetween: 20,
//   speed: 800,
//   keyboard: {
//     enabled: true,
//     onlyInViewport: true,
//   },
//   pagination: {
//     el: ".swiper-pagination",
//     clickable: true, // Ensure bullets are clickable
//   },
//   touchRatio: 2,
//   simulateTouch: true,
//   grabCursor: true,
//   mousewheel: {
//     enabled: true,
//     forceToAxis: true,
//     sensitivity: 2,
//     releaseOnEdges: true,
//   },
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//   breakpoints: {
//     0: {
//       autoHeight: true,
//       spaceBetween: 0,
//     },
//     768: {
//       autoHeight: false,
//       spaceBetween: 15,
//     },
//     992: {
//       autoHeight: false,
//       spaceBetween: 20,
//     },
//   }
// });

// if (window.matchMedia("(min-width: 992px)").matches) {
//   var odd_even_slider_reversed = new Swiper(".reversed .odd_even_slider", {


//     slidesPerView: "auto",
//     centeredSlides: false,
//     allowTouchMove: false,
//     spaceBetween: 20,
//     speed: 800,
//     keyboard: {
//       enabled: true,
//       onlyInViewport: true,
//     },
//     pagination: {
//       el: ".swiper-pagination",
//       clickable: true, // Ensure bullets are clickable
//     },
//     touchRatio: 2,
//     simulateTouch: true,
//     grabCursor: true,
//     mousewheel: {
//       enabled: true,
//       forceToAxis: true,
//       sensitivity: 2,
//       releaseOnEdges: true,
//     },
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//     },
//     breakpoints: {
//       0: {
//         rtl: false,
//         autoHeight: true,
//         spaceBetween: 0,
//       },
//       992: {
//         autoHeight: false,
//         spaceBetween: 20,
//         direction: 'horizontal',
//         rtl: true,
//       },
//     }
//   });
// }

// END ODD EVEN SLIDER - ROOMS PAGE


// ====================================
let mediaWidthMaxGe = window.matchMedia("(min-width: 576px)");

if (mediaWidthMaxGe.matches) {
  setTimeout(() => {
    var geSlider = new Swiper(".grp-entangle-swiper-container", {
      slidesPerView: 1.2,
      spaceBetween: 10,
      centeredSlides: true,
      speed: 1000,
      loop: true,
      // autoplay: true,
      breakpoints: {
        576: {
          slidesPerView: 1.6,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 2.2,
          spaceBetween: 40,
        },
        1600: {
          slidesPerView: 2.5,
          spaceBetween: 80,
        },
        1950: {
          slidesPerView: 4,
          spaceBetween: 80,
        },
      },
    });
  }, 1000);
}

var projectSlider = new Swiper(".project_slider", {
  slidesPerView: 1,
  spaceBetween: 12,
  freeMode: false,
  cssMode: false,
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  navigation: {
    nextEl: ".project_slider .swiper-button-next",
    prevEl: ".project_slider .swiper-button-prev",
  },
  pagination: {
    el: ".project_slider .swiper-pagination",
    clickable: true, // Ensure bullets are clickable
  },
  breakpoints: {
    450: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 16,

    },
    992: {
      slidesPerView: 3,
      spaceBetween: 16,
      simulateTouch: false, allowTouchMove: false,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 24,
      simulateTouch: false, allowTouchMove: false,
    },
  },
});

var mcsSlider = new Swiper(".mcs_slider", {
  slidesPerView: 1,
  spaceBetween: 14,
  autoHeight: true,
  navigation: {
    nextEl: ".mcs_slider .swiper-button-next",
    prevEl: ".mcs_slider .swiper-button-prev",
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  pagination: {
    el: ".mcs_slider .swiper-pagination",
    clickable: true, // Ensure bullets are clickable
  },
  breakpoints: {
    992: {
      simulateTouch: false, allowTouchMove: false,
      autoHeight: false, grabCursor: false,
    },
  },
});
var plProductsSlider = new Swiper(".pl_products_slider", {
  slidesPerView: 1,
  spaceBetween: 12,
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  navigation: {
    nextEl: ".pl_products_slider .swiper-button-next",
    prevEl: ".pl_products_slider .swiper-button-prev",
  },
  pagination: {
    el: ".pl_products_slider .swiper-pagination",
    clickable: true, // Ensure bullets are clickable
  },
  breakpoints: {
    450: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 16,
      spaceBetween: 11, simulateTouch: false, allowTouchMove: false, grabCursor: false
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 24, simulateTouch: false, allowTouchMove: false,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 26, simulateTouch: false, allowTouchMove: false,
    },
  },
});

var owSlider = new Swiper(".ow_slider", {
  slidesPerView: "auto",
  spaceBetween: 24,
  scrollbar: {
    el: ".swiper-scrollbar",
    draggable: true,
  },
  mousewheel: {
    forceToAxis: true, // Only respond to horizontal scroll
    releaseOnEdges: true,
    sensitivity: 0.5,
  },
  navigation: {
    nextEl: ".ow_slider .swiper-button-next",
    prevEl: ".ow_slider .swiper-button-prev",
  },
  pagination: {
    el: ".ow_slider .swiper-pagination",
    clickable: true, // Ensure bullets are clickable
  },
  breakpoints: {
    0: {
      autoHeight: true
    },
    768: {
      autoHeight: false
    },
    992: { autoHeight: false, simulateTouch: false, allowTouchMove: false, grabCursor: false },
  },
});

var swiper = new Swiper(".commercial_slider", {
  slidesPerView: "auto",
  spaceBetween: 25,
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  navigation: {
    nextEl: ".commercial_slider .swiper-button-next",
    prevEl: ".commercial_slider .swiper-button-prev",
  },
  pagination: {
    el: ".commercial_slider .swiper-pagination",
    clickable: true, // Ensure bullets are clickable
  },
  breakpoints: {
    992: { simulateTouch: false, allowTouchMove: false, grabCursor: false },
  },
});

var featuredProjectSlider = new Swiper(".featured_project_slider", {
  spaceBetween: 0,
  // centeredSlides: true,
  // allowTouchMove: false,
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  navigation: {
    nextEl: ".featured_project_slider .swiper-button-next",
    prevEl: ".featured_project_slider .swiper-button-prev",
  },
  pagination: {
    el: ".featured_project_slider .swiper-pagination",
    clickable: true, // Ensure bullets are clickable
  },
  breakpoints: {
    0: {
      slidesPerView: 1.1,
    },
    768: {
      slidesPerView: 1.6,
    },
    992: {
      slidesPerView: 2.4,
      simulateTouch: false, allowTouchMove: false, grabCursor: false,
    },
    1200: {
      slidesPerView: 2.4,
      simulateTouch: false, allowTouchMove: false, grabCursor: false,
    },
  },
});
var featuredProjectSlider = new Swiper(".ia_featured_projects .featured_project_slider", {
  spaceBetween: 20,
  // centeredSlides: true,
  // allowTouchMove: false,
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  navigation: {
    nextEl: ".ia_featured_projects .featured_project_slider .swiper-button-next",
    prevEl: ".ia_featured_projects .featured_project_slider .swiper-button-prev",
  },
  pagination: {
    el: ".ia_featured_projects .featured_project_slider .swiper-pagination",
    clickable: true, // Ensure bullets are clickable
  },
  breakpoints: {
    0: {
      slidesPerView: 1.1,
    },
    768: {
      slidesPerView: 1.6,
    },
    992: {
      slidesPerView: 2.4,
      simulateTouch: false, allowTouchMove: false, grabCursor: false,
    },
    1200: {
      slidesPerView: 2.4,
      simulateTouch: false, allowTouchMove: false, grabCursor: false,
    },
  },
});

const mediaQuery = window.matchMedia('(max-width: 991px)')
// Check if the media query is true

var promotionSlider = new Swiper(".promotion_slider", {
  slidesPerView: 1,
  spaceBetween: 10,
  speed: 1000,
  delay: 300,
  loop: true,
  autoplay: true,
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
  },
})

var cpcSlider = new Swiper(".cpc_slider", {
  slidesPerView: 1,
  spaceBetween: 10,
  speed: 1000,
  delay: 300,
  autoHeight: true,
  // loop: true,
  // autoplay: true,
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  touchRatio: 2,
  simulateTouch: true,
  grabCursor: true,
  mousewheel: {
    enabled: true,
    forceToAxis: true,
    sensitivity: 2,
    releaseOnEdges: true,
  },
  pagination: {
    el: ".swiper-pagination",
  },
  navigation: {
    nextEl: ".cpc_slider .swiper-button-next",
    prevEl: ".cpc_slider .swiper-button-prev",
  },
});
var cpiImageSlider = new Swiper(".cpi_image_slider", {
  slidesPerView: 1,
  spaceBetween: 15,
  autoHeight: true,
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  navigation: {
    nextEl: ".cpi_image_slider .swiper-button-next",
    prevEl: ".cpi_image_slider .swiper-button-prev",
  },
  pagination: {
    el: ".cpi_image_slider .swiper-pagination",
    clickable: true, // Ensure bullets are clickable
  },
  breakpoints: {
    768: {
      slidesPerView: "auto",
      spaceBetween: 25,

    },
    992: {
      slidesPerView: "auto",
      spaceBetween: 25,
      simulateTouch: false, allowTouchMove: false, grabCursor: false,
      autoHeight: false,
    },

  },
});
var aps_slider = new Swiper(".aps_slider", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".aps_slider .swiper-button-next",
    prevEl: ".aps_slider .swiper-button-prev",
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  breakpoints: {
    576: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 26,
    },
    992: {
      slidesPerView: 2,
      spaceBetween: 26,
      simulateTouch: false,
      allowTouchMove: false,
      grabCursor: false
    },
  },
});
var gisSlider = new Swiper(".gis_slider", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".gis_slider .swiper-button-next",
    prevEl: ".gis_slider .swiper-button-prev",
  },
  pagination: {
    el: ".gis_slider .swiper-pagination",
    clickable: true, // Ensure bullets are clickable
    dynamicBullets: true,
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  breakpoints: {
    576: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 24,
    },
    992: {
      slidesPerView: 2,
      spaceBetween: 24,
      simulateTouch: false, allowTouchMove: false, grabCursor: false
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 24,
      simulateTouch: false, allowTouchMove: false,
    },
  },
});

var popupSlider = new Swiper(".popup_product_slider", {
  slidesPerView: 1,
  spaceBetween: 12,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".popup_product_slider .swiper-button-next",
    prevEl: ".popup_product_slider .swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 12,
    },
    1200: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
  },
});

var macProductSlider = new Swiper(".mac_product_slider", {
  slidesPerView: 1,
  spaceBetween: 10,
  pagination: {
    el: ".mac_product_slider .swiper-pagination",
    clickable: true,
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  navigation: {
    nextEl: ".mac_product_slider .swiper-button-next",
    prevEl: ".mac_product_slider .swiper-button-prev",
  },
  breakpoints: {
    450: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 20,
      simulateTouch: false, allowTouchMove: false, grabCursor: false
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 20,
      simulateTouch: false, allowTouchMove: false,
    },

  },
});

jQuery(document).ready(function () {


  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl, {
      html: true,
      trigger: 'hover',
      delay: { show: 0, hide: 10 }
    });
  });

  // Add event listener to add/remove 'active' class
  tooltipTriggerList.forEach(function (tooltipTriggerEl) {
    tooltipTriggerEl.addEventListener('shown.bs.tooltip', function () {
      // Add 'active' class when tooltip is shown
      tooltipTriggerEl.classList.add('active');
      // Add event listener to close tooltip on outside click
      document.addEventListener('click', closeTooltipOnOutsideClick);
    });

    tooltipTriggerEl.addEventListener('hidden.bs.tooltip', function () {
      // Remove 'active' class when tooltip is hidden
      tooltipTriggerEl.classList.remove('active');
      // Remove event listener when tooltip is hidden
      document.removeEventListener('click', closeTooltipOnOutsideClick);
    });
  });

  // Function to close tooltip on outside click
  function closeTooltipOnOutsideClick(event) {
    if (!tooltipTriggerList.some(el => el.contains(event.target))) {
      tooltipList.forEach(function (tooltip) {
        tooltip.hide();
      });
    }
  }
});

// Select all sliders and store their instances in an array
const slidersCollection = [];
/* Removed redundant initialization - now handled in facets.js for better sync 
document.querySelectorAll(".card_product_block_img_slider").forEach((slider, index) => {
  const nextClass = `card-slider-next-${index}`;
  const prevClass = `card-slider-prev-${index}`;
  const pageClass = `card-slider-page-${index}`;
  
  const nextEl = slider.querySelector('.card_product_block_img_slider_next');
  const prevEl = slider.querySelector('.card_product_block_img_slider_prev');
  const pageEl = slider.querySelector('.swiper-pagination');
  
  if (nextEl) nextEl.classList.add(nextClass);
  if (prevEl) prevEl.classList.add(prevClass);
  if (pageEl) pageEl.classList.add(pageClass);

  slidersCollection[index] = new Swiper(slider, {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: `.${nextClass}`,
      prevEl: `.${prevClass}`,
    },
    pagination: {
      el: `.${pageClass}`,
      clickable: true,
    }
  });
});
*/
//// Single Product Media swiper slider
// let galleryThumbs = null;
// let galleryMain = null;

// function initProductSlider() {

//   if (galleryThumbs) galleryThumbs.destroy(true, true);
//   if (galleryMain) galleryMain.destroy(true, true);

//   // THUMB SLIDER
//   galleryThumbs = new Swiper(".thumb_product_slider", {
//     spaceBetween: 10,
//     direction: "horizontal",
//     slidesPerView: 4,
//     watchSlidesVisibility: true,
//     watchSlidesProgress: true,
//     watchOverflow: false,
//     freeMode: false,
//     loop: true,
//     loopedSlides: 20,
//     // slideToClickedSlide: true,
//     breakpoints: {
//       576: {
//         direction: "horizontal",
//         spaceBetween: 15,
//         slidesPerView: 5,
//       },
//       768: {
//         direction: "horizontal",
//         spaceBetween: 15,
//         slidesPerView: 5,
//       },
//       992: {
//         direction: "vertical",
//         spaceBetween: 15,
//         slidesPerView: 5,
//       },
//     },
//   });

//   // MAIN SLIDER
//   galleryMain = new Swiper(".main_product_slider", {
//     direction: "horizontal",
//     spaceBetween: 25,
//     loop: true,
//     loopedSlides: 20,
//     autoHeight: false,
//     speed: 450,
//     breakpoints: {
//       992: {
//         direction: "vertical",
//       },

//     },
//   });

//   // SYNC: Thumb → Main (click)
//   galleryThumbs.on("click", (swiper) => {
//     if (!swiper.clickedSlide) return;
//     const realIndex = swiper.clickedSlide.getAttribute("data-swiper-slide-index");
//     galleryMain.slideToLoop(realIndex, 450);
//   });

//   // NEW SYNC CODE ADDED HERE
//   // Sync main slider → thumbs slider
//   galleryMain.on("slideChangeTransitionStart", function () {
//     galleryThumbs.slideTo(galleryMain.activeIndex);
//   });

//   // Sync thumbs slider → main slider
//   galleryThumbs.on("transitionStart", function () {
//     galleryMain.slideTo(galleryThumbs.activeIndex);
//   });

//   // FIX FOR VERTICAL MODE
//   galleryMain.on("transitionEnd", function () {
//     if (galleryMain.params.direction !== "vertical") return;

//     const active = galleryMain.slides[galleryMain.activeIndex];
//     if (!active) return;

//     const newTranslate = -active.offsetTop;
//     galleryMain.setTranslate(newTranslate);
//   });
// }

// Exposed on window so product-storefront.js.liquid shares the exact same reference.
// (A top-level `let` is NOT on window, causing two separate Swiper instances on live.)
window.galleryThumbs = null;
window.galleryMain = null;

function initProductSlider() {
  // Destroy previous instances (always use window.* to target the shared reference)
  if (window.galleryThumbs) { window.galleryThumbs.destroy(true, true); window.galleryThumbs = null; }
  if (window.galleryMain) { window.galleryMain.destroy(true, true); window.galleryMain = null; }

  // THUMB SLIDER
  window.galleryThumbs = new Swiper(".thumb_product_slider", {
    slidesPerView: 4,
    slidesPerGroup: 1,
    spaceBetween: 10,
    direction: "horizontal",
    watchSlidesProgress: true,
    slideToClickedSlide: false,  // ← was true, caused jump on accidental thumb click
    watchOverflow: true,
    freeMode: false,
    loop: false,
    rewind: false,
    speed: 400,
    navigation: {
      nextEl: ".thumb-swiper-next",
      prevEl: ".thumb-swiper-prev",
      disabledClass: "swiper-button-disabled",
    },
    breakpoints: {
      576: { slidesPerView: 5, slidesPerGroup: 1, spaceBetween: 12 },
      768: { slidesPerView: 5, slidesPerGroup: 1, spaceBetween: 12 },
      992: { direction: "vertical", slidesPerView: 4, slidesPerGroup: 1, spaceBetween: 15 },
    },
  });

  // MAIN SLIDER
  // loop: false — loop:true requires loopDestroy()+loopCreate() after every DOM injection;
  // skipping that caused activeIndex corruption after multiple finish changes.
  window.galleryMain = new Swiper(".main_product_slider", {
    spaceBetween: 20,
    loop: true,
    rewind: false,
    speed: 500,
    autoHeight: false,

    thumbs: {
      swiper: window.galleryThumbs,
    },

    breakpoints: {
      992: {
        direction: "vertical",
      },
    },
  });


}
// Init
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProductSlider);
} else {
  initProductSlider();
}

// Guard: Shopify Section Rendering can re-inject this <script> tag.
if (!window.__pdpSliderListenerBound) {
  window.__pdpSliderListenerBound = true;
}

// const galleryThumbs = new Swiper(".thumb_product_slider", {
//   direction: "vertical",
//   slidesPerView: 4,
//   spaceBetween: 15,
//   watchSlidesProgress: true,
//   watchSlidesVisibility: true,
//   watchOverflow: false,
//   breakpoints: {
//     992: {
//       slidesPerView: 5,
//     },
//   },
// });

// const galleryMain = new Swiper(".main_product_slider", {
//   direction: "vertical",
//   slidesPerView: "auto",
//   spaceBetween: 25,
//   watchSlidesProgress: true,
//   watchSlidesVisibility: true,
//   centeredSlidesBounds: true,
//   thumbs: {
//     swiper: galleryThumbs,
//   },
//   breakpoints: {
//     992: {
//       direction: "vertical",
//     },
//   },
// });

// // Sync sliders normally
// galleryMain.on("slideChangeTransitionStart", function () {
//   galleryThumbs.slideTo(galleryMain.activeIndex);
// });
// galleryThumbs.on("transitionStart", function () {
//   galleryMain.slideTo(galleryThumbs.activeIndex);
// });

// // Scroll-to-top logic when clicking thumbnails
// if (window.matchMedia("(min-width: 992px)").matches) {
//   galleryThumbs.slides.forEach((thumbSlide, index) => {
//     thumbSlide.addEventListener("click", () => {
//       // Move to the correct slide in both sliders
//       galleryMain.slideTo(index);
//       galleryThumbs.slideTo(index);

//       // Scroll main active slide to top
//       setTimeout(() => {
//         const mainSliderEl = document.querySelector(".main_product_slider");
//         const activeSlide = mainSliderEl.querySelector(".swiper-slide-active");
//         if (activeSlide && mainSliderEl) {
//           const containerRect = mainSliderEl.getBoundingClientRect();
//           const slideRect = activeSlide.getBoundingClientRect();
//           const offset = slideRect.top - containerRect.top;

//           mainSliderEl.scrollTo({
//             top: mainSliderEl.scrollTop + offset,
//             behavior: "smooth",
//           });
//         }
//       }, 300);
//     });
//   });
// }

// == //

document.querySelectorAll('.catalogue_content_slider').forEach((container) => {
  const thumbSlider = container.querySelector('.cat_thumbSlider');
  const mainSlider = container.querySelector('.cat_mainSlider');

  if (thumbSlider && mainSlider) {
    const thumbsSwiper = new Swiper(thumbSlider, {
      loop: false,
      spaceBetween: 10,
      slidesPerView: 'auto',
      freeMode: false,
      watchSlidesProgress: true,
      navigation: {
        nextEl: thumbSlider.querySelector('.swiper-button-next'),
        prevEl: thumbSlider.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        768: {
          spaceBetween: 18,
        },
      },
    });

    new Swiper(mainSlider, {
      loop: false,
      spaceBetween: 10,
      autoHeight: true,
      thumbs: {
        swiper: thumbsSwiper,
      },
    });
  }
});

document.querySelectorAll('.catalogue_content_slider').forEach((container) => {
  const thumbSliderSm = container.querySelector('.cat_thumbSlider_sm');
  const mainSliderSm = container.querySelector('.cat_mainSlider_sm');

  if (thumbSliderSm && mainSliderSm) {
    const thumbsSwipersm = new Swiper(thumbSliderSm, {
      loop: false,
      spaceBetween: 10,
      slidesPerView: 'auto',
      freeMode: false,
      watchSlidesProgress: true,
      navigation: {
        nextEl: thumbSliderSm.querySelector('.swiper-button-next'),
        prevEl: thumbSliderSm.querySelector('.swiper-button-prev'),
      },

      breakpoints: {
        450: {
          spaceBetween: 15,
        },
        768: {
          spaceBetween: 15,
        },
        1200: {
          spaceBetween: 40,
        },
      },
    });

    new Swiper(mainSliderSm, {
      loop: false,
      spaceBetween: 10,
      autoHeight: true,
      thumbs: {
        swiper: thumbSliderSm,
      },
    });
  }
});

// Get main slider images
const mainSlides = document.querySelectorAll('.cat_mainSlider');

if (mainSlides) {
  // Dynamically create thumbnail slides using main slider images
  mainSlides.forEach((cat_mainSlider) => {
    cat_mainSlider.querySelectorAll('img').forEach((img) => {
      const slide = document.createElement('div');
      slide.classList.add('swiper-slide');
      const thumbImg = document.createElement('img');
      thumbImg.src = img.getAttribute("data-thumb");
      thumbImg.alt = img.alt;
      slide.appendChild(thumbImg);

      cat_mainSlider.nextElementSibling.querySelector('.swiper-wrapper').appendChild(slide);
    });
  });
}

// Header Searchbar
document.addEventListener('DOMContentLoaded', function () {
  const searchbarBtn = document.querySelector('.search_bar_icon');
  const menuOpening = document.querySelector('.menu-drawer-container');
  const headIcon = document.querySelector('summary.header__icon--menu');

  if (searchbarBtn && menuOpening && headIcon) {
    const parent = searchbarBtn.parentNode;

    searchbarBtn.addEventListener('click', function () {
      parent.classList.toggle('searchbar_active');

      if (parent.classList.contains('searchbar_active')) {
        // Close the menu if it's open
        menuOpening.classList.remove('menu-opening');
        menuOpening.removeAttribute('open');

        const attrs = {
          'aria-label': 'Menu',
          'aria-expanded': 'false',
          'role': 'button',
          'aria-controls': 'menu-drawer'
        };

        for (const [key, value] of Object.entries(attrs)) {
          headIcon.setAttribute(key, value);
        }
      }
    });

    // Close search bar when menu opens
    headIcon.addEventListener('click', function () {
      parent.classList.remove('searchbar_active');
    });
  }
});



jQuery(document).ready(function () {
  jQuery('.main_cart_conttainer , .cart_footer_container').wrapAll('<div class="custom_cart_wrapper"></div>');

  const cartFooter = document.querySelector('.main_cart_footer_wrapper');
  if (cartFooter) {
    cartFooter.classList.contains('is-empty') ? cartFooter.parentElement.classList.add('empty_footer') : cartFooter.parentElement.classList.remove('empty_footer')
  }
})


document.addEventListener('DOMContentLoaded', function () {
  const videoThumbnails = document.querySelectorAll('.video_thumbnail');

  videoThumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener('click', function () {
      // Find the closest parent container for the video thumbnail (could be any class).
      const parentElement = thumbnail.closest('.video_thumbnail').parentNode;
      console.log(parentElement)
      if (parentElement) {
        // Find the hidden video container inside the same parent element
        const videoContainer = thumbnail.nextElementSibling;
        console.log(videoContainer)
        if (videoContainer) {
          // Find the video element inside the video container
          const videoElement = parentElement.querySelector('video');
          console.log(videoElement)
          if (videoElement) {
            // Show the video container
            videoContainer.style.display = 'block';
            // Hide the thumbnail
            thumbnail.style.display = 'none';
            // Play the video
            videoElement.muted = true; // Mute the video to comply with autoplay policies
            videoElement.play().catch((error) => {
              console.error('Autoplay failed:', error);
            });
          } else {
            console.error('No video element found inside video container.');
          }
        } else {
          console.error('Video container not found.');
        }
      } else {
        console.error('Parent element not found.');
      }
    });
  });
});





const playLinks = document.querySelector('.play_vid');

if (playLinks) {
  playLinks.addEventListener('click', function (event) {
    event.preventDefault(); // Prevent default anchor behavior

    const targetId = playLinks.getAttribute('data-target'); // Get the target ID from data-target attribute
    if (targetId) {
      const videoContainer = document.getElementById(targetId); // Find the video container by ID

      if (videoContainer) {
        videoContainer.style.display = 'block'; // Show the video container
        playLinks.style.display = 'none'; // Hide the play playLinks

        // Hide the thumbnail (assumes thumbnail is within videoContainer or a sibling element)
        const thumbnail = document.querySelector(`[data-thumbnail="${targetId}"]`);
        if (thumbnail) {
          thumbnail.style.display = 'none'; // Hide the thumbnail
        }

        const videoElement = videoContainer.querySelector('video'); // Find the video tag inside
        if (videoElement) {
          videoElement.muted = true; // Mute the video to comply with autoplay policies
          videoElement.play().catch((error) => {
            console.error('Autoplay failed:', error);
          });
        }
      } else {
        console.error('Video container not found for target ID:', targetId);
      }
    } else {
      console.error('data-target attribute is missing or empty on the clicked link.');
    }
  });
}


////
document.addEventListener('DOMContentLoaded', () => {
  const dropdown = document.querySelector('.selected-option');
  const optionsContainer = document.querySelector('.dropdown-options');
  const options = document.querySelectorAll('.dropdown-option');
  const selectedOptionText = document.querySelector('.selected-option span');
  const selectedOptionImage = document.querySelector('.selected-option img');
  const goButton = document.getElementById('goButton');
  let selectedValue = 'us'; // Default Value
  let isOpen = false;

  // Guard: only run if the dropdown widget exists on this page
  if (!dropdown || !optionsContainer) return;

  // Open dropdown
  dropdown.addEventListener('click', () => {
    optionsContainer.style.display =
      optionsContainer.style.display === 'flex' ? 'none' : 'flex';
    if (!isOpen) {

      // Open dropdown smoothly

      optionsContainer.style.maxHeight = optionsContainer.scrollHeight + "px";
      optionsContainer.style.opacity = "1";
      // Add 'open-dropdown' class to selected-option
      dropdown.classList.add('open-dropdown');
      isOpen = true;
    } else {
      // Close dropdown smoothly
      optionsContainer.style.maxHeight = "0";
      optionsContainer.style.opacity = "0";
      // Remove 'open-dropdown' class
      dropdown.classList.remove('open-dropdown');
      isOpen = false;
    }
  });

  // Select an option and update flag & text
  options.forEach(option => {
    option.addEventListener('click', () => {
      // selectedValue = option.getAttribute('data-value');
      // console.log("custom selectedValue", selectedValue);
      const newText = option.querySelector('span').textContent.trim();
      // const newImageSrc = option.querySelector('img').src;
      const optionLink = option.querySelector('a');
      const newCurrencyValue = optionLink.getAttribute('data-currency-value');
      dropdown.setAttribute('data-value', newCurrencyValue);
      selectedOptionText.textContent = newText;
      // selectedOptionImage.src = newImageSrc;

      // Hide dropdown
      optionsContainer.style.display = 'none';
      dropdown.classList.remove('open-dropdown');
      optionsContainer.style.maxHeight = "0";
      optionsContainer.style.opacity = "0";
      isOpen = false;
    });
  });

  // Handle "GO" button click
  if (goButton) {
    goButton.addEventListener('click', () => {
      // alert(`You selected: ${selectedValue}`);
      // Add redirect logic here
    });
  }

  // Close dropdown when clicking outside
  window.addEventListener('click', (e) => {
    if (!dropdown.contains(e.target) && !optionsContainer.contains(e.target)) {
      // optionsContainer.style.display = 'none';
      optionsContainer.style.maxHeight = "0";
      optionsContainer.style.opacity = "0";
      isOpen = false;
    }
  });

});


document.addEventListener('DOMContentLoaded', function () {
  // Listen for clicks on all "Add to Cart" buttons inside modals
  const popupCartBtn = document.querySelectorAll('.popup_product_modal .product-form__buttons .product-form__submit')
  if (popupCartBtn) {
    popupCartBtn.forEach(function (button) {
      button.addEventListener('click', function () {
        // Find the closest modal containing the button
        const modal = button.closest('.modal');
        if (modal) {
          // Close the modal using Bootstrap's modal instance
          const bootstrapModal = bootstrap.Modal.getInstance(modal);
          if (bootstrapModal) {
            bootstrapModal.hide();
          }
        }
      });
    });
  }
});

const ppModal = document.querySelectorAll('.popup_product_modal ');
if (ppModal) {
  ppModal.forEach(function (modal) {
    modal.addEventListener('hidden.bs.modal', function () {
      // Get the ID of the modal
      const modalId = this.getAttribute('id');

      // Find the trigger button that corresponds to this modal
      const triggerButton = document.querySelector(`[data-trigger="${modalId}"]`);
      console.log(triggerButton)

      // Move focus back to the trigger button
      if (triggerButton) {
        triggerButton.focus();
      }
    });
  });
}




document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.querySelector('.hc_search input');
  const searchButton = document.querySelector('.hc_search button');
  const noResultMsg = document.querySelector('.no_result_msg');

  function searchGuides(query) {
    const allGuideBlocks = document.querySelectorAll('.medi_guide_block, .pdf_guide_block');
    let matchCount = 0;

    if (!query) {
      allGuideBlocks.forEach(function (block) {
        block.style.display = 'block';
      });
      if (noResultMsg) noResultMsg.style.display = 'none';
      return;
    }

    allGuideBlocks.forEach(function (block) {
      const title = block.querySelector('h6') ? block.querySelector('h6').textContent.toLowerCase() : '';
      const description = block.querySelector('.para') ? block.querySelector('.para').textContent.toLowerCase() : '';

      if (title.includes(query) || description.includes(query)) {
        block.style.display = 'block';
        matchCount++;
      } else {
        block.style.display = 'none';
      }
    });

    if (noResultMsg) noResultMsg.style.display = matchCount === 0 ? 'block' : 'none';
  }

  if (searchButton && searchInput) {
    searchButton.addEventListener('click', function () {
      const query = searchInput.value.toLowerCase();
      searchGuides(query);
    });

    searchInput.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
        const query = searchInput.value.toLowerCase();
        searchGuides(query);
      }
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".slider_common_container").forEach((nasSlider) => {
    const slider = nasSlider.querySelector(".common_swiper_slider .swiper-wrapper");
    const slides = nasSlider.querySelectorAll(".common_swiper_slider .swiper-slide");
    const leftBtn = nasSlider.querySelector(".scroll_left");
    const rightBtn = nasSlider.querySelector(".scroll_right");
    const customPaginations = nasSlider.querySelector(".custom_paginations");

    if (!slider || slides.length === 0 || !leftBtn || !rightBtn || !customPaginations) return;

    function getSlideWidth() {
      const slide = slides[0];
      const style = window.getComputedStyle(slide);
      const marginRight = parseFloat(style.marginRight) || 0;
      return Math.round(slide.offsetWidth + marginRight);
    }

    function getTotalSteps() {
      const slideWidth = getSlideWidth();
      const totalWidth = slider.scrollWidth;
      const visibleWidth = slider.clientWidth;
      const maxScroll = totalWidth - visibleWidth;
      return Math.round(maxScroll / slideWidth) + 1;
    }

    function updateArrows() {
      const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
      const tolerance = 4;
      leftBtn.disabled = slider.scrollLeft <= tolerance;
      rightBtn.disabled = slider.scrollLeft >= (maxScrollLeft - tolerance);
    }

    function createPagination() {
      customPaginations.innerHTML = "";
      const totalSteps = getTotalSteps();

      for (let i = 0; i < totalSteps; i++) {
        const bullet = document.createElement("span");
        bullet.classList.add("swiper-pagination-bullet");
        bullet.setAttribute("role", "button");
        bullet.setAttribute("aria-label", `Go to slide ${i + 1}`);
        bullet.addEventListener("click", () => {
          slider.scrollTo({
            left: i * getSlideWidth(),
            behavior: "smooth"
          });
        });
        customPaginations.appendChild(bullet);
      }
    }

    function updateActiveBullet() {
      const slideWidth = getSlideWidth();
      const bullets = customPaginations.querySelectorAll(".swiper-pagination-bullet");
      const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
      const tolerance = 4;

      let index;
      if (Math.abs(slider.scrollLeft - maxScrollLeft) <= tolerance) {
        index = bullets.length - 1;
      } else {
        index = Math.round(slider.scrollLeft / slideWidth);
      }

      bullets.forEach((b, i) =>
        b.classList.toggle("swiper-pagination-bullet-active", i === index)
      );
    }

    function smoothUpdate() {
      requestAnimationFrame(() => {
        updateArrows();
        updateActiveBullet();
      });
    }

    leftBtn.addEventListener("click", () => {
      slider.scrollBy({ left: -getSlideWidth(), behavior: "smooth" });
      smoothUpdate();
    });

    rightBtn.addEventListener("click", () => {
      slider.scrollBy({ left: getSlideWidth(), behavior: "smooth" });
      smoothUpdate();
    });

    slider.addEventListener("scroll", () => {
      updateArrows();
      updateActiveBullet();
    });

    window.addEventListener("resize", () => {
      createPagination();
      updateArrows();
      updateActiveBullet();
    });

    createPagination();
    updateArrows();
    updateActiveBullet();
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//     document.querySelectorAll(".slider_common_container").forEach((nasSlider) => {
//         console.log(nasSlider);
//         const slider = nasSlider.querySelector(".common_swiper_slider .swiper-wrapper");
//         const slides = nasSlider.querySelectorAll(".common_swiper_slider .swiper-slide");
//         const leftBtn = nasSlider.querySelector(".scroll_left");
//         const rightBtn = nasSlider.querySelector(".scroll_right");

//         if (!slider || slides.length === 0 || !leftBtn || !rightBtn) return;

//         function getSlideWidth() {
//             const slide = slides[0];
//             const style = window.getComputedStyle(slide);
//             const marginRight = parseFloat(style.marginRight) || 0;
//             return slide.offsetWidth + marginRight;
//         }

//         function updateArrows() {
//             const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
//             leftBtn.disabled = slider.scrollLeft <= 0;
//             rightBtn.disabled = slider.scrollLeft >= maxScrollLeft - 2; // Adjusted for precision
//         }

//         leftBtn.addEventListener("click", () => {
//             slider.scrollBy({ left: -getSlideWidth(), behavior: "smooth" });
//             setTimeout(updateArrows, 100); // Adjust delay for animation
//         });

//         rightBtn.addEventListener("click", () => {
//             slider.scrollBy({ left: getSlideWidth(), behavior: "smooth" });
//             setTimeout(updateArrows, 100);
//         });

//         slider.addEventListener("scroll", updateArrows);
//         updateArrows(); // Initialize state
//     });
// });

const contactID = document.querySelector('a[href="#contactFormId"]');
if (contactID) {


  contactID.addEventListener('click', function (e) {
    e.preventDefault();
    const targetId = this.getAttribute('href').substring(1); // Remove the '#' from href
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      // Check if a child with class 'submitted_successfully' exists
      const hasSubmittedSuccess = targetElement.querySelector('.submitted_successfully') !== null;
      const offset = hasSubmittedSuccess ? 100 : 80;

      const offsetTop = targetElement.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    }
  });

}

document.addEventListener("DOMContentLoaded", function () {
  const containersSpm = document.querySelectorAll(".spm_media_img");
  if (containersSpm) {
    containersSpm.forEach(container => {
      const img = container.querySelector("img");

      container.addEventListener("mousemove", function (e) {
        const { left, top, width, height } = container.getBoundingClientRect();
        const x = ((e.clientX - left) / width) * 100;
        const y = ((e.clientY - top) / height) * 100;

        img.style.transform = `scale(2.5) translate(${(50 - x) / 1.5}%, ${(50 - y) / 1.5}%)`;
      });

      container.addEventListener("mouseleave", function () {
        img.style.transition = "transform 0.6s ease-in-out"; /* Smooth return */
        img.style.transform = "scale(1)";
      });

      container.addEventListener("mouseenter", function () {
        img.style.transition = "transform 0s ease-out"; /* Smooth zoom-in */
      });
    });
  }

  const containers = document.querySelectorAll('.catalogue_group_container');
  if (containers) {
    containers.forEach((container, index) => {
      container.id = `catlink-${index + 1}`;
    });
  }


  const piorityshipping = document.querySelector('.piorityshipping');
  if (piorityshipping) {

    const priorityVariantId = 49775128281392;
    const priorityShippingTitle = 'Priority shipping';
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const foundItem = cart.items.find(item =>
          item.product_title.trim().toLowerCase() === priorityShippingTitle.toLowerCase()
        );

        if (foundItem && piorityshipping) {
          piorityshipping.value = 'Yes';
        } else if (piorityshipping) {
          piorityshipping.value = 'No';
        }
      })
      .catch(error => console.error('Cart fetch error:', error));

    piorityshipping.addEventListener('change', function () {
      const selectedValue = this.value;

      if (selectedValue === 'Yes') {
        // Add priority shipping to cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: priorityVariantId,
            quantity: 1
          })
        })
          .then(response => response.json())
          .then(data => {
            console.log('Priority shipping added:', data);
            window.location.reload();
          })
          .catch(error => console.error('Add error:', error));
      } else {
        // Get current cart to find line item key
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const item = cart.items.find(i => i.variant_id === priorityVariantId);
            if (item) {
              // Remove item using line item key
              fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({
                  id: item.key,
                  quantity: 0
                })
              })
                .then(response => response.json())
                .then(data => {
                  console.log('Priority shipping removed:', data);
                  window.location.reload();
                })
                .catch(error => console.error('Remove error:', error));
            }
          });
      }
    });


  }
});

function getUrlParameter(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}
// Check if 'selectedListId' is in the URL query parameters
const selectedhKey = getUrlParameter('hkey');
const selectedListId = getUrlParameter('lid');
// If 'selectedListId' exists in the URL, store it as a cookie (acting like a session)
if (selectedListId) {
  // Set the cookie to store the selectedListId for 1 day (adjust expiration as needed)
  sessionStorage.setItem('selectedListId', selectedListId);
  // alert(sessionStorage.getItem('selectedListId'));
  if (window.location.pathname.includes('swym-share-wishlist')) {
    const newUrl = `${window.Shopify?.routes?.root}pages/swym-product?hkey=${encodeURIComponent(selectedhKey)}&lid=${encodeURIComponent(selectedListId)}&utm_source=swym-Wishlist&utm_medium=shared-wishlist&utm_campaign=${encodeURIComponent(selectedListId)}`;
    // alert(newUrl);
    setTimeout(() => {
      window.location.href = newUrl; // More reliable in Safari
    }, 100);
    ;
  }
}

window.addEventListener("load", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const hasPosted = urlParams.get("customer_posted") === "true";
  const hash = window.location.hash;

  if (hasPosted && hash === "#contact_form") {
    setTimeout(() => {
      const target = document.querySelector(hash);
      if (target) {
        const offset = 300; // Adjust to your desired spacing
        const topPos = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({ top: topPos, behavior: "smooth" });
      }
    }, 1000); // Delay long enough to override native jump
  }
});


document.querySelectorAll('.cmn-product-share').forEach(function (el) {
  el.addEventListener('click', function (event) {
    event.preventDefault();

    // const productAvailable = this.getAttribute("data-product-available");
    // if (productAvailable === "true") { // Uncomment if you want to check availability

    let productId = this.getAttribute("data-product-id");
    let getProductUrl = this.getAttribute("data-product-url");
    let productTitle = this.getAttribute("data-product-title");
    let productImage = this.getAttribute("data-product-image");

    let productUrl = `${window.location.origin}${getProductUrl}`;

    document.getElementById("share-facebook").href = `https://www.facebook.com/sharer/sharer.php?u=${productUrl}`;
    document.getElementById("share-twitter").href = `https://twitter.com/intent/tweet?text=${productTitle}&url=${productUrl}`;
    document.getElementById("share-linkedin").href = `https://www.linkedin.com/shareArticle?mini=true&url=${productUrl}&title=${productTitle}`;
    document.getElementById("share-pinterest").href = `https://www.pinterest.com/pin/create/button/?url=${productUrl}&media=${productImage}&description=${productTitle}`;

    document.getElementById("productLink").value = productUrl;

    let modal = new bootstrap.Modal(document.getElementById("acfProductModal"));
    modal.show();

    // }
  });
});

document.getElementById("confirmSubmitBtn").addEventListener("click", () => {
  if (pendingForm && pendingInput && pendingSelectedValue !== null) {
    pendingInput.value = pendingSelectedValue;
    pendingForm.submit();
  }

  // Clean up
  pendingForm = null;
  pendingInput = null;
  pendingSelectedValue = null;

  // Hide the modal
  const modalEl = document.getElementById("confirmModal");
  const modalInstance = bootstrap.Modal.getInstance(modalEl);
  if (modalInstance) modalInstance.hide();
});




function updateActiveSliderImage(cardBlock, newImageUrl) {
  const imgEl =
    cardBlock.querySelector('.swiper-slide-active img') ||
    cardBlock.querySelector('.is-active img') ||
    cardBlock.querySelector('.active img');

  if (!imgEl) return;

  // Store initial image only once
  if (!imgEl.dataset.initialSrc) {
    imgEl.dataset.initialSrc = imgEl.src;
    imgEl.dataset.initialSrcset = imgEl.srcset || '';
  }

  // If new image exists → use it
  if (newImageUrl) {
    imgEl.src = newImageUrl;
    if (imgEl.srcset !== undefined) {
      imgEl.srcset = newImageUrl;
    }
  }
  // Else → restore initial image
  else {
    imgEl.src = imgEl.dataset.initialSrc;
    if (imgEl.srcset !== undefined) {
      imgEl.srcset = imgEl.dataset.initialSrcset;
    }
  }
}
setTimeout(() => {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  if (tooltipTriggerList) {
    tooltipTriggerList.forEach(el => new bootstrap.Tooltip(el));
  }

  //   const mobFacetCheckBox = document.querySelectorAll('.mobile-facets__item input[type="checkbox"]');

  // if (mobFacetCheckBox.length) {
  //   mobFacetCheckBox.forEach(function (checkbox) {
  //     checkbox.addEventListener('change', function () {
  //       const label = checkbox.parentElement; // .facets__label.facet-checkbox

  //       if (label && label.classList.contains('facet-checkbox')) {
  //         label.classList.toggle('active', checkbox.checked);
  //       }
  //     });
  //   });
  // }

}, 1000);

(function () {
  if (!document.body.classList.contains('template-cart')) return;
  // Helper to parse query string
  function getCartProductsFromURL() {
    const cartWrapper = document.querySelector('.custom_cart_wrapper');
    const params = new URLSearchParams(window.location.search);
    const raw = params.get('cart-products');
    if (!raw) {
      if (cartWrapper) {
        if (cartWrapper.classList.contains('cart-loading')) {
          cartWrapper.classList.remove('cart-loading');
        }
      }
      return [];
    } else {
      if (cartWrapper) {
        cartWrapper.classList.add('cart-loading');
      }
      console.log("item found");
      return raw.split(',').map(item => {
        const [id, qty] = item.split(':');
        return {
          id: parseInt(id, 10),
          quantity: parseInt(qty, 10)
        };
      });
    }
  }

  // Add items to cart via Shopify AJAX API
  async function addItemsToCart(items) {
    if (!items.length) return;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) throw new Error('Cart update failed');

      // Optionally refresh or redirect to cart
      console.log('Items added:', items);
      setTimeout(() => {
        window.location.href = window.Shopify?.routes?.root + 'cart'; // Stay on cart page
      }, 200);

    } catch (error) {
      console.error('Error adding items:', error);
    }
  }

  // Run if the cart-products param exists
  const itemsToAdd = getCartProductsFromURL();
  if (itemsToAdd.length) {
    addItemsToCart(itemsToAdd);
  }
})();

const bottomLink = document.querySelectorAll('a[href]');
const bottomRegex = /#bottom$/;

bottomLink.forEach(link => {
  if (bottomRegex.test(link.getAttribute('href'))) {
    link.addEventListener('click', function (event) {
      event.preventDefault();

      const allowElement = document.querySelector('#allow-scroll');

      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });

    });
  }
});
document.querySelectorAll(".thumb-swiper-prev, .thumb-swiper-next").forEach(function (btn) {
  btn.addEventListener("click", function (e) {
    if (btn.classList.contains("swiper-button-disabled")) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }, true); // capture phase — fires before Swiper or fancybox
});

// For Our Story page
(function () {
    'use strict';

    function bindVideoBlocks(root) {
        const scope = root || document;
        const blocks = scope.querySelectorAll('.apm_video_block:not([data-bound])');

        blocks.forEach((block) => {
            const btn = block.querySelector('.video_play_btn');
            const thumb = block.querySelector('.video_thumbnail');
            const content = block.querySelector('.video_content');

            if (!btn || !thumb || !content) return;

            block.setAttribute('data-bound', 'true');

            btn.addEventListener('click', () => {
                thumb.style.display = 'none';
                content.style.display = 'block';

                const iframe = content.querySelector('iframe');
                const video = content.querySelector('video');

                if (iframe) {
                    const src = iframe.getAttribute('data-src');
                    if (src) {
                        iframe.src = `${src}${src.includes('?') ? '&' : '?'}autoplay=1`;
                    }
                } else if (video) {
                    video.play().catch(() => {});
                }
            }, { once: true });
        });
    }

    document.addEventListener('DOMContentLoaded', () => bindVideoBlocks());
    document.addEventListener('shopify:section:load', (e) => bindVideoBlocks(e.target));
})();

// Common sidebar Slider JS
document.addEventListener('DOMContentLoaded', function () {
  let cswSwipers = [];

  function initCswSwiper() {
    const elements = document.querySelectorAll('.csw_listings_swiper');
    if (!elements.length) return;

    if (window.innerWidth < 992) {
      elements.forEach((el, index) => {
        if (!cswSwipers[index]) {
          const scrollbarEl = el.querySelector('.swiper-scrollbar');
          cswSwipers[index] = new Swiper(el, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            freeMode: true,
            scrollbar: scrollbarEl ? {
              el: scrollbarEl,
              draggable: true,
              hide: false,
            } : undefined,
          });
        }
      });
    } else {
      cswSwipers.forEach((instance) => {
        if (instance) instance.destroy(true, true);
      });
      cswSwipers = [];
    }
  }

  initCswSwiper();
  window.addEventListener('resize', () => {
    clearTimeout(window._cswResizeTimer);
    window._cswResizeTimer = setTimeout(initCswSwiper, 150);
  });
});

/* ==========================================================================
   Lazy Loading Background Images Engine
   ========================================================================== */
(function () {
  function loadBg(el) {
    var bgUrl = el.getAttribute('data-bg');
    if (!bgUrl) return;
    el.style.backgroundImage = "url('" + bgUrl + "')";
    el.classList.add('lazy-bg-loaded');
    el.removeAttribute('data-bg');
  }

  function initLazyBgObserver() {
    var lazyElements = document.querySelectorAll('[data-bg]');
    if (!lazyElements.length) return;

    if ('IntersectionObserver' in window) {
      var bgObserver = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting || entry.intersectionRatio > 0) {
              loadBg(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '300px 0px 300px 0px' }
      );

      lazyElements.forEach(function (el) {
        if (!el.hasAttribute('data-bg-observing')) {
          el.setAttribute('data-bg-observing', 'true');
          bgObserver.observe(el);
        }
      });

      if (!window._lazyBgMutationObserver) {
        window._lazyBgMutationObserver = new MutationObserver(function (mutations) {
          var addedNodesExist = false;
          mutations.forEach(function (m) {
            if (m.addedNodes && m.addedNodes.length) addedNodesExist = true;
          });
          if (addedNodesExist) {
            document.querySelectorAll('[data-bg]:not([data-bg-observing])').forEach(function (el) {
              el.setAttribute('data-bg-observing', 'true');
              bgObserver.observe(el);
            });
          }
        });
        window._lazyBgMutationObserver.observe(document.body, { childList: true, subtree: true });
      }
    } else {
      lazyElements.forEach(function (el) {
        loadBg(el);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyBgObserver);
  } else {
    initLazyBgObserver();
  }

  document.addEventListener('shopify:section:load', initLazyBgObserver);
})();
